var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":false,"opacity":"0"}},[_c('v-progress-circular',{attrs:{"size":150,"width":7,"color":"black","indeterminate":""}},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }